import { HiSearch } from "react-icons/hi";
/**
 * Returns the search bar component to search through data.
 *
 * @returns The search bar component to search through the data.
 */
const SearchBar = ({
  searchTerm,
  currentPage,
  getProjects,
  handleSearch,
  searchPurpose,
  setCurrentPage,
  onSearchSubmit,
}) => {
  return (
    <>
      <div className="py-0 mb-4">
        <div className="flex justify-between">
          <div className="relative flex flex-1 items-center">
            <input
              type="search"
              value={searchTerm}
              placeholder="Search"
              onChange={handleSearch}
              className="w-full pl-10 py-2 pr-3 bg-purple-white shadow-sm rounded-md border border-gray-300"
            />

            <div className="absolute m-3.5 text-purple-lighter">
              <HiSearch className="w-5 h-5 text-gray-400"/>
            </div>
          </div>

          <button
            className="text-white inline-flex items-center justify-center ml-4 px-10 py-2 border text-sm sm:text-base
                                leading-6 font-medium rounded-md bg-blue-700 hover:bg-blue-500 focus:outline-none 
                                focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
            onClick={(e) => {
              if (currentPage !== 0) {
                setCurrentPage(0);
              } else {
                if (searchPurpose === "doi" || searchPurpose === "logs") {
                  getProjects();
                } else {
                  onSearchSubmit(e);
                }
              }
            }}
          >
            Search
          </button>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
